import React, { Component } from "react";
import { interval, from, of } from "rxjs";
import { switchMap, first, timeout, catchError } from "rxjs/operators";
import apiProxy from "../api/apiProxy.js";
import ToastContext from "./toastContext";

const ManagersOverrideToastContext = React.createContext();

export class ManagersOverrideToastProvider extends Component {
  static contextType = ToastContext;

  state = { toasts: [] };

  count = 0;

  managersOverridesToMonitor = [];

  monitorManagersOverrideState = storeId => {
    // Don't set up a new monitor for an override which is already being monitored
    if (this.managersOverridesToMonitor.includes(storeId)) {
      return;
    }

    this.managersOverridesToMonitor.push(storeId);
    interval(30000)
      .pipe(
        switchMap(() => from(apiProxy.storeLighting.getStoreStatus(storeId))),
        first(x => x.managersOverrideEngaged === false),
        timeout(720000),
        catchError(error => of(`Request timed out`))
      )
      .subscribe(result => {
        this.managersOverridesToMonitor = this.managersOverridesToMonitor.filter(
          o => o !== storeId
        );

        if (result === `Request timed out`) {
          this.addOverrideToast(true, storeId);
        } else {
          this.addOverrideToast(result.managersOverrideEngaged, storeId);
        }
      });
  };

  addOverrideToast = (managersOverrideEngaged, storeId) => {
    if (managersOverrideEngaged) {
      this.context.add(
        "warning",
        `Manager's override notification`,
        `It looks like things are taking a little longer than expected for Store ID ${storeId}.`
      );
    } else {
      this.context.add(
        "success",
        `Manager's override notification`,
        `Manager's override was successfully turned off for Store ID ${storeId}.`
      );
    }
  };

  render() {
    const managersOverrideContext = {
      add: this.context.add,
      remove: this.context.remove,
      monitorManagersOverrideState: this.monitorManagersOverrideState
    };

    return (
      <ManagersOverrideToastContext.Provider value={managersOverrideContext}>
        {this.props.children}
      </ManagersOverrideToastContext.Provider>
    );
  }
}

export default ManagersOverrideToastContext;
